import { render, staticRenderFns } from "./TheNavbar.vue?vue&type=template&id=3ac58c9c"
import script from "./TheNavbar.vue?vue&type=script&lang=ts"
export * from "./TheNavbar.vue?vue&type=script&lang=ts"
import style0 from "./TheNavbar.vue?vue&type=style&index=0&id=3ac58c9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports